import { render } from "./merchant_consent.vue?vue&type=template&id=3ccd0912"
import script from "./merchant_consent.vue?vue&type=script&lang=js"
export * from "./merchant_consent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__